var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "106px",
        height: "106px",
        viewBox: "0 0 106 106",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("defs", [
        _c("polygon", {
          attrs: {
            id: "path-1",
            points: "0 0.5719 56.4035188 0.5719 56.4035188 4.749525 0 4.749525"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-HD",
                transform: "translate(-1361.000000, -413.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Group",
                    transform: "translate(1361.000000, 413.000000)"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M106,90.9548646 C106,99.2637914 99.2146745,106 90.8451633,106 L15.1548367,106 C6.78532554,106 0,99.2637914 0,90.9548646 L0,15.0451354 C0,6.73520562 6.78532554,0 15.1548367,0 L90.8451633,0 C99.2146745,0 106,6.73520562 106,15.0451354 L106,90.9548646 Z",
                      id: "Mask",
                      fill: "#FFCAE7"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group-6",
                        transform: "translate(25.000000, 25.000000)"
                      }
                    },
                    [
                      _c("path", {
                        attrs: {
                          d:
                            "M20.098675,28.3385 L20.098675,33.1799375 L12.1388625,33.1799375 L12.0973,28.3943125 L20.098675,28.3385 Z M12.156675,42.2951875 L20.098675,42.2951875 L20.098675,37.4145625 L12.156675,37.4145625 L12.156675,42.2951875 Z M32.1292375,16.3198125 L32.1292375,33.1799375 L24.2846125,33.1799375 L24.2299875,16.3744375 L32.1292375,16.3198125 Z M24.292925,42.2951875 L32.1292375,42.2951875 L32.1292375,37.4145625 L24.292925,37.4145625 L24.292925,42.2951875 Z M44.2488625,4.1170625 L44.2488625,15.124 L36.2973625,15.124 L36.2463,4.1740625 L44.2488625,4.1170625 Z M36.310425,42.2951875 L44.2488625,42.2951875 L44.2488625,19.32775 L36.310425,19.32775 L36.310425,42.2951875 Z M10.0678625,46.4728125 L46.337675,46.4728125 C47.48955,46.4728125 48.4264875,45.5346875 48.4264875,44.384 L48.4264875,3.591 C48.4264875,1.61025 46.8162375,0 44.836675,0 L35.721425,0 C33.740675,0 32.1292375,1.61025 32.1292375,3.591 L32.1292375,12.200375 L23.7051125,12.200375 C21.72555,12.200375 20.1153,13.8118125 20.1153,15.7925625 L20.1153,24.22025 L11.5712375,24.22025 C9.5904875,24.22025 7.97905,25.832875 7.97905,27.8124375 L7.97905,44.384 C7.97905,45.5346875 8.9159875,46.4728125 10.0678625,46.4728125 L10.0678625,46.4728125 Z",
                          id: "Fill-1",
                          fill: "#FFFFFF"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Group-5",
                            transform: "translate(0.000000, 50.133638)"
                          }
                        },
                        [
                          _c(
                            "mask",
                            { attrs: { id: "mask-2", fill: "white" } },
                            [_c("use", { attrs: { "xlink:href": "#path-1" } })]
                          ),
                          _vm._v(" "),
                          _c("g", { attrs: { id: "Clip-4" } }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d:
                                "M54.3147063,0.5719 L2.08845625,0.5719 C0.93776875,0.5719 -0.00035625,1.5088375 -0.00035625,2.6607125 C-0.00035625,3.8125875 0.93776875,4.749525 2.08845625,4.749525 L54.3147063,4.749525 C55.4665813,4.749525 56.4035188,3.8125875 56.4035188,2.6607125 C56.4035188,1.5088375 55.4665813,0.5719 54.3147063,0.5719",
                              id: "Fill-3",
                              fill: "#FFFFFF",
                              mask: "url(#mask-2)"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }